import React from 'react';
import { Job } from '../types';
import JobCard from './JobCard';
import JobListItem from './JobListItem';

type ViewMode = 'grid' | 'list';

interface JobListProps {
    jobs: Job[];
    viewMode: ViewMode;
}

const JobList: React.FC<JobListProps> = ({ jobs, viewMode }) => {
    if (viewMode === 'list') {
      return (
        <div className="space-y-2">
          {jobs.map(job => (
            <JobListItem key={job.id} job={job} />
          ))}
        </div>
      );
    }

    return (
        <div className="grid grid-cols-1 gap-x-4 gap-y-3 md:grid-cols-2 xl:grid-cols-3">
            {jobs.map(job => (
                <JobCard key={job.id} job={job} />
            ))}
        </div>
    );
};

export default JobList;
